import React from "react";
import { useSelector } from "react-redux";

import {
    getCurrentLocale,
    getLocales,
} from "@redux/modules/value/locales/locales.selectors";

import LanguageSelector from "./languageSelector.component";

const LanguageSelectorSidebar = () => {
    const locales = useSelector(getLocales);
    const current: string = useSelector(getCurrentLocale);

    return (
        <LanguageSelector
            layout="list"
            variant="small"
            current={current}
            languages={locales}
        />
    );
};

export { LanguageSelectorSidebar };
